import { CLIENT_TOKEN } from "../constants";

const shortProductId = (longId) => longId && longId.productId ? parseInt(longId.productId.split(`/${CLIENT_TOKEN}products/`)[1]): longId

export default shortProductId;